// eslint-disable-next-line no-restricted-imports
import packageJson from '../../../package.json';

export const getVersion = () => {
  return packageJson.version;
};
